import React, {useState} from "react";
import {Form, FormControl, Button} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import Header from "../Header/Header";
import NavBar from "../Header/NavBar";

const OrderSearch = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();

    const searchOrder = (e) => {
        e.preventDefault();
        if (searchTerm.trim()) {
            navigate(`/order/${searchTerm}`);
        }
    };

    const toNewOrder = () => {
        navigate('/newOrder');
    }

    return (
        <>
            <div>
                <Header/>
            </div>
            <div style={{marginTop: "40px"}}>
                <NavBar/>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "100px",
                    marginLeft: "100px",
                }}
            >
                <div className="p-3">
                    <Form className="d-flex" onSubmit={searchOrder}>
                        <FormControl
                            type="search"
                            placeholder="Search orders"
                            className="me-2"
                            aria-label="Search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <Button variant="primary" type="submit">
                            Search
                        </Button>
                    </Form>
                    <Button className="me-2" variant="primary" onClick={toNewOrder} style={{marginTop:"40px"}}>
                        Create New order
                    </Button>
                </div>
            </div>
        </>
    );
};

export default OrderSearch;
